<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-3">
            <a @click="openPage('/userManagement/user')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
          <div class="col-md-4 text-right">
            <a class="btn-primary text-center" v-b-modal="'modalNewPass'"><i class="fas fa-cog mr-5"></i>Reset Password</a>
            <b-modal modal-class="modal-custom-image" hide-footer centered id="modalNewPass">
              <div class="p-10">
                <form @submit.prevent="validateNewPass('changePassForm')" data-vv-scope="changePassForm">
                  <div class="mb-10">
                    <input ref="pw_confirm" v-model="changePassData.new_password" type="text" placeholder="Default Password" class="w-100" v-validate="'required'" name="new_password" value="Paradigm1234" disabled>
                    <span class="error">{{ errors.first('changePassForm.new_password') }}</span>
                  </div>
                  <div class="text-right">
                    <button type="submit" class="btn-primary">Submit</button>
                  </div>
                </form>
              </div>
            </b-modal>
          </div>
          <div class="col-md-4 text-right">
            <a class="btn-secondary text-center" v-b-modal="'modalChangePass'"><i class="fas fa-cog mr-5"></i>Change Password</a>
            <b-modal modal-class="modal-custom-image" hide-footer centered id="modalChangePass">
              <div class="p-10">
                <form @submit.prevent="validateChangePass('changePassForm')" data-vv-scope="changePassForm">
                  <div class="mb-10">
                    <input type="password" v-model="changePassData.old_password" placeholder="Current Password" class="w-100" v-validate="'required'" name="current_password">
                    <span class="error">{{ errors.first('changePassForm.current_password') }}</span>
                  </div>
                  <div class="mb-10">
                    <input ref="pw_confirm" v-model="changePassData.new_password" type="password" placeholder="New Password" class="w-100" v-validate="'required'" name="new_password">
                    <span class="error">{{ errors.first('changePassForm.new_password') }}</span>
                  </div>
                  <div class="mb-10">
                    <input type="password" v-model="changePassData.confirm_password" placeholder="Confirm New Password" class="w-100" v-validate="'required|confirmed:pw_confirm'" name="confirm_new_password">
                    <span class="error">{{ errors.first('changePassForm.confirm_new_password') }}</span>
                  </div>
                  <div class="text-right">
                    <button type="submit" class="btn-primary">Save</button>
                  </div>
                </form>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>ID User</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input disabled v-model="editData.employee_id" name="user_id" v-validate="'required|numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('user_id') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>First Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.first_name" name="first_name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('first_name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Last Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.last_name" name="last_name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('last_name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Email</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input disabled v-model="editData.email" name="email" v-validate="'required|email'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('email') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Staff</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="staff_status" v-model="editData.is_staff">
                    <option :value="null">Please select</option>
                    <option :value="1">Yes</option>
                    <option :value="0">No</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('staff_status') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Status</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="staff_status" v-model="editData.status">
                    <option :value="null">Please select</option>
                    <option :value="1">Active</option>
                    <option :value="0">Inactive</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('staff_status') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20" v-if="getRoleId == 1">
                <b-col sm="2">
                  <label>Resign Date</label>
                </b-col>
                <b-col sm="10">
                  <flat-pickr :config="config" v-model="editData.resign_date" name="resign_date" class="w-100"></flat-pickr>
                  <span class="error">{{ errors.first('resign_date') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'

export default {
  name: 'addSales',
  data: function () {
    return {
      dataBranch: [],
      changePassData: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      editData: {
        employee_id: '',
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        resign_date: null,
        is_staff: null,
        parent: 'user_crm',
        status: 1
      },
      config: {
        altInput: true,
        altFormat: 'j F Y',
        dateFormat: 'Y-m-d'
      },
      confirm_password: '',
      imageData: '',
      imgUpload: null,
      salesRole: '',
      branchSalesId: '',
      getRoleId: Auth.Session.get().paradigm_role,
      file: null,
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ]
    }
  },
  methods: {
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          if(this.editData.is_staff == 1) {
            this.editData.resign_date = null
          }

          this.editData.status = this.editData.status == 1 ? 'active' : 'inactive'
          this.editData.resign_date = this.editData.resign_date == '' ? null : this.editData.resign_date
          axios.put('vendor/v1/user/' + this.$route.query.id, this.editData).then(response => {
            // console.log('test', response)
            this.$router.push('/userManagement/user')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error log', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    validateChangePass (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          axios.put('vendor/v1/user/change_password/' + this.$route.query.id, this.changePassData).then(response => {
            // console.log('test', response)
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
            this.$router.push('/userManagement/user')
          }).catch(error => {
            console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    validateNewPass (scope) {
      this.$validator.validateAll(scope).then(async (result) => {
        if (result) {
          let isConfirm = await this.$swal({
              title: 'Are you sure?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
              showCloseButton: true,
              showLoaderOnConfirm: false
          })
          if (isConfirm.value) {
            axios.put('vendor/v1/user/generate/new_password/crm/' + this.$route.query.id, this.changePassData).then(response => {
              // console.log('test', response)
              this.$toast.success('data saved successfully!', 'Success', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
              this.$router.push('/userManagement/user')
            }).catch(error => {
              console.log('error', error)
              this.$toast.success('cant saved data!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            })
          } else {
            this.$swal('Cancelled', 'Your transaction cancelled', 'info')
          }

        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      axios.get('vendor/v1/user/' + this.$route.query.id).then(response => {
        this.editData.employee_id = this.$route.query.id
        this.editData = response.data.data
        this.editData.first_name = response.data.data.staff ? response.data.data.staff.first_name : ''
        this.editData.last_name = response.data.data.staff ? response.data.data.staff.last_name : ''
        this.editData.email = response.data.data.email
        this.editData.password = response.data.data.password
        this.editData.status = response.data.data.status == 'active' ? 1 : 0
        if(!response.data.data.resign_date) {
          this.editData.resign_date = moment(new Date()).format('YYYY-MM-DD')
        }
        this.editData.is_staff = response.data.data.is_staff
        // console.log('test', response.data.data)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
